module.exports = __webpack_public_path__ + "img/46.7fa242c3.png";